import dataTableMessages from "../../i18n/lstrings"

const TextLabels = (intl) => ({
  body: {
    noMatch: intl.formatMessage(dataTableMessages.bodyNoMatch),
    toolTip: intl.formatMessage(dataTableMessages.bodyToolTip),
    columnHeaderTooltip: (column) =>
      intl.formatMessage(dataTableMessages.bodyColumnHeaderTooltip, {
        label: column.label
      })
  },
  pagination: {
    next: intl.formatMessage(dataTableMessages.paginationNext),
    previous: intl.formatMessage(dataTableMessages.paginationPrevious),
    rowsPerPage: intl.formatMessage(dataTableMessages.paginationRowsPerPage),
    displayRows: intl.formatMessage(dataTableMessages.paginationDisplayRows)
  },
  toolbar: {
    search: intl.formatMessage(dataTableMessages.toolbarSearch),
    downloadCsv: intl.formatMessage(dataTableMessages.toolbarDownloadCsv),
    print: intl.formatMessage(dataTableMessages.toolbarPrint),
    viewColumns: intl.formatMessage(dataTableMessages.toolbarViewColumns),
    filterTable: intl.formatMessage(dataTableMessages.toolbarFilterTable)
  },
  filter: {
    all: intl.formatMessage(dataTableMessages.filterAll),
    title: intl.formatMessage(dataTableMessages.filterTitle),
    reset: intl.formatMessage(dataTableMessages.filterReset)
  },
  viewColumns: {
    title: intl.formatMessage(dataTableMessages.viewColumnsTitle),
    titleAria: intl.formatMessage(dataTableMessages.viewColumnsTitleAria)
  },
  selectedRows: {
    text: intl.formatMessage(dataTableMessages.selectedRowsText),
    delete: intl.formatMessage(dataTableMessages.selectedRowsDelete),
    deleteAria: intl.formatMessage(dataTableMessages.selectedRowsDeleteAria)
  }
})

export default TextLabels
